import { formatUserLocalStorageKey, UNIQ_LOCAL_STORAGE_KEYS } from 'app/persistedState';
import {
  INVENTORY_ATS_COLUMNS,
  INVENTORY_ATS_COLUMNS_STORAGE_SETTINGS,
  INVENTORY_ATS_COLUMNS_DEFAULT_ORDER,
  INVENTORY_ATS_FILTERS,
  INVENTORY_ATS_QUICK_FILTERS,
} from './inventoryAts';


export {
  INVENTORY_ATS_COLUMNS,
  INVENTORY_ATS_COLUMNS_STORAGE_SETTINGS,
  INVENTORY_ATS_COLUMNS_DEFAULT_ORDER,
  INVENTORY_ATS_FILTERS,
  INVENTORY_ATS_QUICK_FILTERS,
};

export const ACTIONS = {
  INIT_CONTAINER: 'INVENTORY_ATS__INIT_CONTAINER',
  EXIT_CONTAINER: 'INVENTORY_ATS__EXIT_CONTAINER',

  SET_IS_FETCHING_FEED: 'INVENTORY_ATS__SET_IS_FETCHING_FEED',

  LOAD_INVENTORY_ATS: 'INVENTORY_ATS__LOAD',
  LOAD_INVENTORY_ATS_SUCCESS: 'INVENTORY_ATS_SUCCESS',
  LOAD_INVENTORY_ATS_ERROR: 'INVENTORY_ATS_ERROR',
  LOAD_FEED: 'INVENTORY_ATS__LOAD_FEED',

  SET_COLUMNS: 'INVENTORY_ATS__SET_COLUMNS',
  SET_COLUMNS_ORDER: 'INVENTORY_ATS__SET_COLUMNS_ORDER',
  SET_COLUMN_ENABLED: 'INVENTORY_ATS__SET_COLUMN_ENABLED',
  SORT_FEED: 'INVENTORY_ATS__SORT_FEED',
  SET_ITEMS_PER_PAGE: 'INVENTORY_ATS__SET_ITEMS_PER_PAGE',

  SHOW_OPTIONS_MODAL: 'INVENTORY_ATS__SHOW_OPTIONS_MODAL',
  TOGGLE_INCLUDE_SPECIAL_ZONES:'TOGGLE_INCLUDE_SPECIAL_ZONES',
  GO_TO_PAGE: 'INVENTORY_ATS__GO_TO_PAGE',
  REFRESH_INVENTORY_FEED: 'INVENTORY_ATS__REFRESH_INVENTORY_ATS',
  SORT_INVENTORY_FEED: 'INVENTORY_ATS__SORT_INVENTORY_ATS',
  SET_FILTER_OPERAND: 'INVENTORY_ATS__SET_FILTER_OPERAND',
  UNSET_FILTER_OPERAND: 'INVENTORY_ATS__UNSET_FILTER_OPERAND',
  CLEAR_FILTERS: 'INVENTORY_ATS__CLEAR_FILTERS',
  SET_FILTERS: 'INVENTORY_ATS__SET_FILTERS',
  ARRANGE_FILTERS: 'INVENTORY_ATS__ARRANGE_FILTERS',
  // ship_types
  SET_SHIP_TYPES : 'SET_SHIP_TYPES',
  ADD_SHIP_TYPE : 'ADD_SHIP_TYPE',
  REMOVE_SHIP_TYPE : 'REMOVE_SHIP_TYPE',

  EXPORT_TO_FILE: 'INVENTORY_ATS__EXPORT_TO_FILE',
  EXPORT_TO_FILE_SUCCESS: 'INVENTORY_ATS__EXPORT_TO_FILE_SUCCESS',
  EXPORT_TO_FILE_ERROR: 'INVENTORY_ATS__EXPORT_TO_FILE_ERROR',

  GET_FILTERED_INVENTORY_ATS:'INVENTORY_ATS__FILTERED_INVENTORY_ATS',
  SET_INVENTORY_ATS_TYPE: 'INVENTORY_ATS__SET_ORDER_VIEW_TYPE',
  SET_FILTER_OPTIONS: 'INVENTORY_ATS__SET_FILTER_OPTIONS',
  SET_COLUMN_FILTER_OPTIONS: 'INVENTORY_ATS__SET_COLUMN_FILTER_OPTIONS',
  SET_QUICK_FILTER_OPTIONS: 'INVENTORY_ATS__SET_QUICK_FILTER_OPTIONS',

};


export const INVENTORY_ATS_LOCAL_STORAGE_KEY = username =>
  formatUserLocalStorageKey(username, UNIQ_LOCAL_STORAGE_KEYS.INVENTORY_ATS);


export const INVENTORY_ATS_ERRORS = {
  NO_RESULTS_FOR_SO: salesOrderNumber =>
    `Something went wrong! No search results found for SO# ${salesOrderNumber}`,
};


export const INVENTORY_ATS_FILTER_OPTIONS = {
  INVENTORY_ATS_FILTERS,
};

export const INVENTORY_ATS_COLUMN_FILTER_OPTIONS = {
  INVENTORY_ATS_FILTERS,
};

export const INVENTORY_ATS_QUICK_FILTER_OPTIONS = {
  INVENTORY_ATS_QUICK_FILTERS,
};
